import { render } from "./SuccessfulSignUpModal.vue?vue&type=template&id=70374be2"
import script from "./SuccessfulSignUpModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulSignUpModal.vue?vue&type=script&lang=js"

import "./SuccessfulSignUpModal.vue?vue&type=style&index=0&id=70374be2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__